"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Marketplace/components/Installed.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Favicon_template = require("../../Favicon.marko"),
    Favicon_tag = marko_loadTag(Favicon_template),
    marko_loadNestedTag = require("marko/dist/runtime/helpers/load-nested-tag"),
    Row_col_nested_tag = marko_loadNestedTag("col", 1),
    marko_mergeNestedTagsHelper = require("marko/dist/runtime/helpers/merge-nested-tags"),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "px-3 py-2 theme-bg-primary"
      },
    marko_attrs1 = {
        "class": "py-1 white-text"
      };

function render(input, out, __component, component, state) {
  var data = input;

  const Installed = window.Extensions.installed()

  if (Installed.length) {
    out.be("section", marko_attrs0, "0", component);

    out.be("h5", null, "1", component);

    Locale_tag({
        text: "Installed",
        class: "font-medium-1 white-text"
      }, out, __component, "2");

    out.ee();

    Row_tag(marko_mergeNestedTagsHelper({
        renderBody: function(out, $nestedTagRow$0) {
          var $for$0 = 0;

          marko_forOf(Installed, function(each, index) {
            const { name, description, favicon } = each

            var $keyScope$0 = "[" + (($for$0++) + "]");

            Row_col_nested_tag({
                qs: "col-4",
                hs: "col-2",
                fs: "col-1",
                class: "py-2 text-center cursor-pointer",
                renderBody: function(out) {
                  out.be("div", {
                      title: Locale("Run " + name)
                    }, "5" + $keyScope$0, component, null, 0, {
                      onclick: __component.d("click", () => component.emit('run', name ), false)
                    });

                  Favicon_tag(marko_assign({
                      width: 44
                    }, each, {
                      class: "font-large-1"
                    }), out, __component, "6" + $keyScope$0);

                  out.e("div", marko_attrs1, "7" + $keyScope$0, component, 1)
                    .t(name, component);

                  out.ee();
                }
              }, $nestedTagRow$0);
          });
        }
      }), out, __component, "3");

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
